import React, { useEffect, useState } from 'react';
import './home.css';
import anonymous1 from '../../assets/anonymous1.png';

const roles = ['Full-Stack Developer', 'Cybersecurity Specialist', 'Content Creator'];

const Home = () => {
  const [displayText, setDisplayText] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [deleting, setDeleting] = useState(false);

  // Typewriter effect
  useEffect(() => {
    const current = roles[wordIndex % roles.length];
    let timeout;

    if (!deleting && displayText === current) {
      timeout = setTimeout(() => setDeleting(true), 2000);
    } else if (deleting && displayText === '') {
      setDeleting(false);
      setWordIndex((i) => i + 1);
    } else {
      timeout = setTimeout(() => {
        setDisplayText(current.slice(0, deleting ? displayText.length - 1 : displayText.length + 1));
      }, deleting ? 60 : 120);
    }

    return () => clearTimeout(timeout);
  }, [displayText, deleting, wordIndex]);

  // Smooth scroll function
  const handleScrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="home" id="home">
      <div className="home__container">
        {/* Left Side - Content */}
        <div className="home__content">
          <div className="home__badge">
            <span className="badge-dot"></span>
            Open to opportunities
          </div>

          <h1 className="home__title">
            Hi, I'm <br />
            <span className="title-highlight">Professor01</span>
          </h1>

          <div className="home__role">
            <span className="role-label">I'm a</span>
            <span className="role-text">{displayText}</span>
            <span className="role-cursor">|</span>
          </div>

          <p className="home__description">
            Building digital experiences with clean code and creative solutions.
            CEO at IT Pro Mastery.
          </p>

          <div className="home__actions">
            <a 
              href="https://t.me/itpromastery" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="btn btn-primary"
            >
              Let's Connect
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
            <a 
              href="#work" 
              className="btn btn-secondary"
              onClick={(e) => {
                e.preventDefault();
                handleScrollToSection('work');
              }}
            >
              View My Work
            </a>
          </div>

          {/* Social Links */}
          <div className="home__socials">
            <a href="https://github.com/itpromastery" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="GitHub">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.15 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.62.24 2.85.12 3.15.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
              </svg>
            </a>
            <a href="https://www.linkedin.com/itpromastery" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
              </svg>
            </a>
            <a href="#" className="social-link" aria-label="Twitter">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="#" className="social-link" aria-label="YouTube">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
              </svg>
            </a>
          </div>
        </div>

        {/* Right Side - Avatar */}
        <div className="home__visual">
          <div className="avatar-wrapper">
            <div className="avatar-ring"></div>
            <div className="avatar-ring ring-2"></div>
            <img 
              src={anonymous1} 
              alt="Professor01" 
              className="avatar-image"
            />
            <div className="avatar-status">
              <span className="status-dot"></span>
              Available
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div 
        className="scroll-indicator"
        onClick={() => handleScrollToSection('about')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleScrollToSection('about');
          }
        }}
      >
        <span className="scroll-text">Scroll</span>
        <div className="scroll-line"></div>
      </div>
    </section>
  );
};

export default Home;